import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid
} from '@material-ui/core';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { makeStyles } from '@material-ui/styles';
import ProgressFullScreen from '../Compartilhados/ProgressFullScreen';
import SnackbarCustom from '../Compartilhados/Snackbar';
import { ServiceValues } from '../../values/ServiceValues';
import { ServiceAxios } from '../../services/ServiceEW';
import { Values } from '../../values/Values';
import moment from 'moment';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    marginRight: 10,
    marginLeft: 10,
    backgroundColor: theme.palette.background.paper,
    borderBottomLeftRadius: 20,
    borderBottomRightRadius: 20,
    borderTopRightRadius: 35,
    borderTopLeftRadius: 35
  }
}));

function DialogRelatorioFiliados(props) {
  const { open, setOpen } = props;
  const classes = useStyles();
  const [dataInicio, setDataInicio] = useState(null);
  const [dataFim, setDataFim] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showMessageSnack, setShowMessageSnack] = useState(false);
  const [messageSnack, setMessageSnack] = useState('');
  const [typeSnack, setTypeSnack] = useState('success');

  const timeout = ServiceValues.timeout;
  const baseUrl = ServiceValues.base_url_local;
  const api = ServiceAxios(baseUrl, timeout);

  async function gerarRelatorio() {
    try {
      if (!dataInicio || !dataFim) {
        setTypeSnack('warning');
        setMessageSnack('Por favor, selecione as datas inicial e final');
        setShowMessageSnack(true);
        return;
      }

      if (dataInicio > dataFim) {
        setTypeSnack('warning');
        setMessageSnack('Data inicial não pode ser maior que data final');
        setShowMessageSnack(true);
        return;
      }

      setLoading(true);
      setOpen(false);

      const dataInicialFormatada = moment(dataInicio).format('YYYY-MM-DD');
      const dataFinalFormatada = moment(dataFim).format('YYYY-MM-DD');

      const params = {
        dataInicial: dataInicialFormatada,
        dataFinal: dataFinalFormatada
      };

      const response = await api.get('relatorio/relatorio-visitas-mensal', {
        params: params,
        responseType: 'blob'
      });

      setLoading(false);

      if (response && response.data) {
        // Criar download automático do arquivo CSV
        const fileURL = window.URL.createObjectURL(response.data);
        const link = document.createElement('a');
        link.href = fileURL;
        link.setAttribute(
          'download',
          `Relatorio-Filiados-${dataInicialFormatada}-${dataFinalFormatada}.csv`
        );
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(fileURL);

        // Resetar formulário
        setDataInicio(null);
        setDataFim(null);

        setTypeSnack('success');
        setMessageSnack('Relatório gerado e baixado com sucesso');
        setShowMessageSnack(true);
      } else {
        setTypeSnack('error');
        setMessageSnack('Erro ao gerar relatório');
        setShowMessageSnack(true);
      }
    } catch (error) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack(
        error.response?.data?.message ||
          Values.MessageValues.erro_catch ||
          'Erro ao gerar relatório'
      );
      setShowMessageSnack(true);
    }
  }

  function handleClose() {
    setOpen(false);
    setDataInicio(null);
    setDataFim(null);
  }

  return (
    <Grid container spacing={2}>
      <Grid item md={12} xs={12}>
        <SnackbarCustom
          verticalOrientation="bottom"
          horizontalOrientation="center"
          open={showMessageSnack}
          setOpen={setShowMessageSnack}
          message={messageSnack}
          duration={2000}
          type={typeSnack}
        />
      </Grid>
      <Grid item md={12} xs={12}>
        <ProgressFullScreen open={loading} setOpen={setLoading} />
      </Grid>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth={'xs'}
        fullWidth>
        <DialogTitle id="alert-dialog-title">
          Gerar Relatório de Filiados
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item md={12} xs={12} style={{ marginTop: '10px' }}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  fullWidth
                  margin="dense"
                  inputVariant="outlined"
                  orientation="landscape"
                  id="dataInicio"
                  label="Data Inicial"
                  format="dd/MM/yyyy"
                  size="small"
                  value={dataInicio}
                  onChange={setDataInicio}
                  KeyboardButtonProps={{
                    'aria-label': 'change date'
                  }}
                  InputAdornmentProps={{ position: 'end' }}
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item md={12} xs={12}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  fullWidth
                  margin="dense"
                  inputVariant="outlined"
                  orientation="landscape"
                  id="dataFim"
                  label="Data Final"
                  format="dd/MM/yyyy"
                  size="small"
                  value={dataFim}
                  onChange={setDataFim}
                  KeyboardButtonProps={{
                    'aria-label': 'change date'
                  }}
                  InputAdornmentProps={{ position: 'end' }}
                />
              </MuiPickersUtilsProvider>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancelar
          </Button>
          <Button onClick={gerarRelatorio} color="primary" variant="contained">
            Gerar Relatório
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
}

export default DialogRelatorioFiliados;
